import getGameKeyFromSlug from '@domain/Tournament/helpers/getGameKeyFromSlug';
import { isPlatformSlug } from '@Types/platform';
const MOBILE_ADD_GAME_WEBVIEW_ACTION = 'show-game-modal-webview';
const getMobileAddGameWebViewConfig = (pathname, search, isReactNativeWebView) => {
    if (!isReactNativeWebView) {
        return null;
    }
    const urlSearchParams = new URLSearchParams(search);
    if (urlSearchParams.get('webViewAction') !== MOBILE_ADD_GAME_WEBVIEW_ACTION) {
        return null;
    }
    const pathSegments = pathname.split('/').filter(Boolean);
    if (pathSegments.length === 0) {
        return null;
    }
    const filterByPlatform = isPlatformSlug(pathSegments[0]);
    const gameSlug = filterByPlatform ? pathSegments[1] : pathSegments[0];
    if (!gameSlug) {
        return null;
    }
    const gameKey = getGameKeyFromSlug(gameSlug);
    if (!gameKey) {
        return null;
    }
    return {
        gameKey,
        filterByPlatform,
    };
};
export default getMobileAddGameWebViewConfig;
